import React from 'react';
import styles from './excelBtn.css';
import ExcelVariantIcon from '../../../../assets/svg/excel.svg';

/***********************************************************************************************************************
 *
 * @param onclick
 * @param caption
 * @returns {*}
 * @constructor
 **********************************************************************************************************************/
const ExcelBtn = React.memo( ( { onclick, caption } ) => {
    return (
        <a onClick={ onclick } className={ styles.excelExport }>
            <ExcelVariantIcon className={ styles.iconExport }/>
            <span>{ caption }</span>
        </a>
    );
} );

export default ExcelBtn;
